import React, { Suspense } from 'react';
import {
  validateMandatory,
  validatePostalCodeLength,
} from '../components/address-field-dapi/validate';

const Component = React.lazy(() => import('../components/address-field-dapi-simple'));

export default function (dependencies) {
  const { language } = dependencies;
  const html = (props) => {
    const componentProps = { ...props, ...dependencies };
    return (
      <Suspense fallback={<span>Loading...</span>}>
        <Component {...componentProps}></Component>
      </Suspense>
    );
  };

  return {
    html,
    validators: [
      function (state, config, props) {
        if (config.soft) {
          if (state.isMatched || state.zipValidated) return;
          return language['address-missing'];
        }
        const { street_name, street_number, zip } = state;
        if (!validateMandatory(street_name)) return language['address-missing'];
        if (!validateMandatory(street_number)) return language['address-missing'];
        if (!validateMandatory(zip)) return language['address-missing'];
        if (!validatePostalCodeLength(zip, props.globalConfig.countryCode))
          return language['address-missing'];
      },
    ],
    config: {
      validators: ['mandatory'],
    },
  };
}
